module.exports = __webpack_public_path__ + "img/Jenit.4765859e.jpeg";